import { render, staticRenderFns } from "./alphabet-control.vue?vue&type=template&id=255c0e6f&"
import script from "./alphabet-control.vue?vue&type=script&lang=js&"
export * from "./alphabet-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports